var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialFb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 0C4.92494 0 0.000244141 4.95468 0.000244141 11.067C0.000244141 16.5905 4.02294 21.1689 9.28204 22V14.2653H6.48804V11.067H9.28204V8.6289C9.28204 5.85553 10.9232 4.32386 13.4367 4.32386C14.6401 4.32386 15.8985 4.53966 15.8985 4.53966V7.26214H14.5125C13.1452 7.26214 12.7195 8.1154 12.7195 8.99079V11.067H15.7698L15.2825 14.2653H12.7195V22C17.9775 21.17 22.0002 16.5894 22.0002 11.067C22.0002 4.95468 17.0755 0 11.0002 0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFb);
export default __webpack_public_path__ + "static/media/social_fb.d296f7b570b3b7a7106a8309aff381b8.svg";
export { ForwardRef as ReactComponent };